<template>
  <div>
    <ul class="list-group list-group-flush">
      <li v-for="(o, i) in gsmOperators" :key="i" class="list-group-item d-flex justify-content-between">
        <div class="operator-apn text-truncate mr-5">
          <span>MCC: {{ o.operatorMcc }}</span>
          <span class="ml-3">MNC: {{ o.operatorMnc }}</span>
        </div>

        <div v-if="o.operatorApn" style="flex: 1;">APN: {{ o.operatorApn }}</div>

        <div>
          <i :id="'gsmOperators-editOperator-' + i" class="icon-edit" @click="showEditOperatorForm(i, o)" />
          <i :id="'gsmOperators-deleteOperator-' + i" class="icon-trash" @click="confirmDeleteOperator(i)" />
        </div>
      </li>
    </ul>

    <confirm id="deleteOperator"
             v-model="showDeleteOperatorConfirm"
             :message="$t('gc-backhaulGsmOperators:confirmDelete')"
             @confirm:validate="deleteOperator"
    />

    <backhaul-gsm-operators-form v-model="showOperatorForm"
                                 :operator-to-edit="operatorToEdit"
                                 @update-operator="updateOperator"
                                 @cancel="operatorToEdit={}"
    />
  </div>
</template>

<script>
import BackhaulGsmOperatorsForm from './BackhaulGsmOperatorsForm'

export default {
  components: { BackhaulGsmOperatorsForm },

  model: {
    prop: 'gsmOperators',
    event: 'change'
  },

  props: {
    gsmOperators: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      // Add / edit
      showOperatorForm: false,
      indexOperatorToEdit: null,
      operatorToEdit: null,
      // Delete
      showDeleteOperatorConfirm: false,
      indexOperatorToDelete: null
    }
  },

  methods: {
    showEditOperatorForm (i, operator) {
      this.indexOperatorToEdit = i
      this.operatorToEdit = operator
      this.showOperatorForm = true
    },

    updateOperator (operator) {
      // Do not mutate props
      const operators = this.gsmOperators.concat()

      operators[this.indexOperatorToEdit] = operator

      this.$emit('change', operators)
      this.indexOperatorToEdit = null
      this.operatorToEdit = null
    },

    confirmDeleteOperator (i) {
      this.indexOperatorToDelete = i
      this.showDeleteOperatorConfirm = true
    },

    deleteOperator () {
      // Do not mutate props
      const operators = this.gsmOperators.concat()
      operators[this.indexOperatorToDelete] = {
        operatorApn: '',
        operatorLogin: '',
        operatorPassword: '',
        operatorMcc: '',
        operatorMnc: ''
      }

      this.$emit('change', operators)
      this.indexOperatorToDelete = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .operator-apn {
    width: 200px;
  }
</style>
